
  import { defineComponent, PropType } from 'vue';

  import { TStatisticsPublicFilter } from '../../../types/statistics/statistics-public';
  import StatisticsVisitsCountTabs from '../StatisticsVisitsCountTabs.vue';
  import StatisticsPublicVisitsCountByTimeTab from './StatisticsPublicVisitsCountByTimeTab.vue';

  export default defineComponent({
    name: 'StatisticsPublicVisitsCountTabs',
    components: {
      StatisticsVisitsCountTabs,
      StatisticsPublicVisitsCountByTimeTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
  });
